import * as C from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as c } from "../../utilities/transformations.js";
import { distort as _ } from "../../helpers/distort.js";
import { grain as w } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as E } from "../../utilities/uv.js";
const O = {
  name: "Vapor8",
  collection: "vapor",
  tags: ["wave", "gradient", "colorful"],
  props: {
    colorA: {
      type: String,
      default: "#0075C4",
      transform: c,
      description: "The first color of the vapor wave."
    },
    colorB: {
      type: String,
      default: "#a24ad5",
      transform: c,
      description: "The second color of the vapor wave."
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the waves"
    }
  },
  fragmentNode: (o) => {
    const {
      vec4: a,
      uv: m,
      time: l,
      sin: i,
      mix: e,
      abs: d,
      smoothstep: p,
      blendOverlay: f,
      color: r,
      float: n
    } = C, u = 0.1, F = 29, v = 0.9, t = _(m(), 0.1, 1, F), g = i(
      t.y.mul(1.5).mul(Math.PI).sub(l.mul(o.speed.uniform).mul(0.5))
    ).mul(0.2).add(0.5).sub(u), h = e(
      o.colorA.uniform,
      o.colorB.uniform,
      t.x
    ), b = d(t.y.sub(g)).mul(2), s = p(
      n(0.5),
      0,
      b.mul(n(0.5))
    ), { correctedUV: T } = E(), y = w(1)(T), A = h.mul(s).sub(y);
    return f(a(
      e(
        r("#FFFFFF"),
        A,
        s.mul(v)
      ),
      1
    ), r("#FFFFFF"));
  }
};
export {
  O as componentDefinition,
  O as default
};
